export const warningColors = (warn: boolean) => {
	return warn ? 'text-amber-600' : 'text-slate-800 dark:text-slate-200';
};
